import React from 'react';

import {
  Container,
  Label,
  List,
  ToggleButton,
  ToggleGroupSize,
} from './styles';

export type ToggleItem = {
  value: string;
  icon?: React.ReactNode;
  label?: React.ReactNode;
  disabled?: boolean;
};

export type ToggleGroupProps = {
  items: ToggleItem[];
  value: string;
  onChange: (value: string) => void;
  label?: React.ReactNode;
  size?: ToggleGroupSize;
  color?: string;
  activeColor?: string;
  activeBackgroundColor?: string;
  borderColor?: string;
  className?: string;
};

const ToggleGroup = ({
  items,
  value,
  onChange,
  label,
  size = 'md',
  color,
  activeColor,
  activeBackgroundColor,
  borderColor,
  className,
}: ToggleGroupProps): JSX.Element => {
  return (
    <Container className={className}>
      {label && <Label>{label}</Label>}
      <List role="group">
        {items.map((item) => {
          const isActive = item.value === value;

          return (
            <ToggleButton
              key={item.value}
              type="button"
              aria-label={typeof item.label === 'string' ? item.label : item.value}
              aria-pressed={isActive}
              disabled={item.disabled}
              title={typeof item.label === 'string' ? item.label : undefined}
              $size={size}
              $active={isActive}
              $color={color}
              $activeColor={activeColor}
              $activeBackgroundColor={activeBackgroundColor}
              $borderColor={borderColor}
              onClick={() => {
                if (!item.disabled) onChange(item.value);
              }}
            >
              {item.icon || item.label}
            </ToggleButton>
          );
        })}
      </List>
    </Container>
  );
};

export default ToggleGroup;
